import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import {
  FETCH_EQUIPMENT_CONFIGS_REQUEST,
  CREATE_EQUIPMENT_CONFIG_REQUEST,
  UPDATE_EQUIPMENT_CONFIG_REQUEST,
  DELETE_EQUIPMENT_CONFIG_REQUEST,
  fetchEquipmentConfigsSuccess,
  fetchEquipmentConfigsFailure,
  createEquipmentConfigSuccess,
  createEquipmentConfigFailure,
  updateEquipmentConfigSuccess,
  updateEquipmentConfigFailure,
  deleteEquipmentConfigSuccess,
  deleteEquipmentConfigFailure,
} from "../dux/equipmentConfig";
import {
  getEquipmentConfigsUrl,
  createEquipmentConfigUrl,
  updateEquipmentConfigUrl,
  deleteEquipmentConfigUrl,
} from "../helpers/apiEndPoints";

const getErrorMessage = (payload, fallback) =>
  payload?.data?.message ||
  payload?.data?.error ||
  payload?.message ||
  fallback;

const equipmentConfigMiddleware = () => (next) => (action) => {
  next(action);

  if (action.type === FETCH_EQUIPMENT_CONFIGS_REQUEST) {
    const { filters } = action.payload || {};
    next(apiCallStart({ api: "fetchEquipmentConfigs" }));
    next(
      apiAction({
        url: getEquipmentConfigsUrl(),
        method: "GET",
        data: filters || {},
        feature: FETCH_EQUIPMENT_CONFIGS_REQUEST,
      })
    );
  }

  if (action.type === CREATE_EQUIPMENT_CONFIG_REQUEST) {
    const { data } = action.payload || {};
    next(apiCallStart({ api: "createEquipmentConfig" }));
    next(
      apiAction({
        url: createEquipmentConfigUrl(),
        method: "POST",
        data,
        feature: CREATE_EQUIPMENT_CONFIG_REQUEST,
      })
    );
  }

  if (action.type === UPDATE_EQUIPMENT_CONFIG_REQUEST) {
    const { id, data } = action.payload || {};
    next(apiCallStart({ api: "updateEquipmentConfig" }));
    next(
      apiAction({
        url: updateEquipmentConfigUrl(id),
        method: "PUT",
        data,
        feature: UPDATE_EQUIPMENT_CONFIG_REQUEST,
      })
    );
  }

  if (action.type === DELETE_EQUIPMENT_CONFIG_REQUEST) {
    const { id } = action.payload || {};
    next(apiCallStart({ api: "deleteEquipmentConfig" }));
    next(
      apiAction({
        url: deleteEquipmentConfigUrl(id),
        method: "DELETE",
        feature: DELETE_EQUIPMENT_CONFIG_REQUEST,
      })
    );
  }

  if (action.type === `${FETCH_EQUIPMENT_CONFIGS_REQUEST} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "fetchEquipmentConfigs" }));
    next(fetchEquipmentConfigsSuccess(action.payload));
  }

  if (action.type === `${FETCH_EQUIPMENT_CONFIGS_REQUEST} ${API_ERROR}`) {
    next(apiCallComplete({ api: "fetchEquipmentConfigs" }));
    next(
      fetchEquipmentConfigsFailure(
        getErrorMessage(action.payload, "Failed to fetch equipment configs")
      )
    );
  }

  if (action.type === `${CREATE_EQUIPMENT_CONFIG_REQUEST} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "createEquipmentConfig" }));
    next(createEquipmentConfigSuccess(action.payload));
  }

  if (action.type === `${CREATE_EQUIPMENT_CONFIG_REQUEST} ${API_ERROR}`) {
    next(apiCallComplete({ api: "createEquipmentConfig" }));
    next(
      createEquipmentConfigFailure(
        getErrorMessage(action.payload, "Failed to create equipment config")
      )
    );
  }

  if (action.type === `${UPDATE_EQUIPMENT_CONFIG_REQUEST} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "updateEquipmentConfig" }));
    next(updateEquipmentConfigSuccess(action.payload));
  }

  if (action.type === `${UPDATE_EQUIPMENT_CONFIG_REQUEST} ${API_ERROR}`) {
    next(apiCallComplete({ api: "updateEquipmentConfig" }));
    next(
      updateEquipmentConfigFailure(
        getErrorMessage(action.payload, "Failed to update equipment config")
      )
    );
  }

  if (action.type === `${DELETE_EQUIPMENT_CONFIG_REQUEST} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "deleteEquipmentConfig" }));
    next(deleteEquipmentConfigSuccess(action.payload));
  }

  if (action.type === `${DELETE_EQUIPMENT_CONFIG_REQUEST} ${API_ERROR}`) {
    next(apiCallComplete({ api: "deleteEquipmentConfig" }));
    next(
      deleteEquipmentConfigFailure(
        getErrorMessage(action.payload, "Failed to update equipment config")
      )
    );
  }
};

export default equipmentConfigMiddleware;
